import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, CalendarClock, Home, ShieldCheck, Wrench } from "lucide-react";
import { AppHeader } from "@/components/site/AppHeader";
import { AskShieldsChat } from "@/components/chat/AskShieldsChat";
import { PageHeader, PageShell } from "@/components/ui/shields-layout";

export const Route = createFileRoute("/_authenticated/customer/ai")({
  head: () => ({
    meta: [
      { title: "Shields AI — Shields" },
      {
        name: "description",
        content: "Ask Shields for help preparing home-service and home-management next steps.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: CustomerAiPage,
});

function CustomerAiPage() {
  return (
    <div className="min-h-screen bg-background pb-24">
      <AppHeader workspace="customer" />
      <PageShell width="standard">
        <PageHeader className="mb-5" eyebrow="Shields AI" title="Help with your home and services" description="Ask for guidance, explanations and help preparing your next step. Shields AI will not silently book, pay, cancel or accept anything for you." />

        <section className="mb-5 grid gap-3 sm:grid-cols-3" aria-label="Useful Shields destinations">
          <Link to="/book" className="card-surface flex min-h-24 items-center gap-3 p-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <Wrench className="h-5 w-5" aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <strong className="block">Book a service</strong>
              <small className="mt-1 block text-sm text-muted-foreground">Start a real service request</small>
            </span>
            <ArrowRight className="h-4 w-4 text-muted-foreground" aria-hidden />
          </Link>
          <Link to="/home" className="card-surface flex min-h-24 items-center gap-3 p-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <Home className="h-5 w-5" aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <strong className="block">My Home</strong>
              <small className="mt-1 block text-sm text-muted-foreground">History, reminders and documents</small>
            </span>
            <ArrowRight className="h-4 w-4 text-muted-foreground" aria-hidden />
          </Link>
          <Link to="/bookings" className="card-surface flex min-h-24 items-center gap-3 p-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
              <CalendarClock className="h-5 w-5" aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <strong className="block">Activity</strong>
              <small className="mt-1 block text-sm text-muted-foreground">Track jobs and next actions</small>
            </span>
            <ArrowRight className="h-4 w-4 text-muted-foreground" aria-hidden />
          </Link>
        </section>

        <AskShieldsChat audience="customer" className="h-[70dvh] min-h-[34rem] max-h-[48rem]" />

        <p className="mt-4 flex items-start gap-2 text-xs leading-5 text-muted-foreground">
          <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          Important actions remain in the normal Shields flow so you can review and confirm them yourself.
        </p>
      </PageShell>
    </div>
  );
}
